import { Injectable } from '@angular/core';
import { APIService } from './api.service';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class EmailService extends APIService{
  constructor(private _http: HttpClient) { super(); }

  public requestResetPassword(email: string): Observable<any> {
    return this._http.post(`${this._baseUrl}/v1/emails/reset-password`, {email: email});
  }
}
